import {Column} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {GetUser, MeID, Me} from "../Server/DB/users";
import {Observer, PageContainer} from "web-vcore";
import {JournalUI} from "./Journal/JournalUI";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.64, .06, .12, .18];

export const JournalPage = observer_mgl(()=>{
	const user = Me();
	if (user == null) return <PageContainer>You must be signed in to access this page.</PageContainer>;

	return (
		<>
			<JournalUI user={user}/>
		</>
	);
});